import { PERMISSIONS } from 'contexts/PermissionsContext';
import { SPEND_TYPE } from '../constants';

export const ROOT_ROUTE = '/data/append';

export const CONFIG = [
	{
		path: `${ROOT_ROUTE}/indirect`,
		name: SPEND_TYPE.INDIRECT,
		label: 'Indirect spend',
		required: PERMISSIONS.RawDataWrite,
	},
	{
		path: `${ROOT_ROUTE}/direct`,
		name: SPEND_TYPE.DIRECT,
		label: 'Direct spend',
		required: PERMISSIONS.RawDataWrite,
	},
];
